export default "__VITE_ASSET__3ffL1Pcj__"